import { getAuth, signInWithCredential, GoogleAuthProvider } from "firebase/auth";

class GoogleOneTapService {
    constructor() {
        this.auth = getAuth();
        // החלף את זה ב-Client ID שלך מ-Google Cloud Console
        this.CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "602544022028-a1ua06ev58o7q7jgqj3c6qlvk1p50tbc.apps.googleusercontent.com";
        this.isInitialized = false;
    }

    // פונקציה שמטפלת בתשובה מגוגל
    handleCredentialResponse = (response) => {
        try {
            // גוגל מחזירה JWT Token
            const idToken = response.credential;

            // יצירת Credential שמתאים ל-Firebase
            const credential = GoogleAuthProvider.credential(idToken);

            // התחברות ל-Firebase
            return signInWithCredential(this.auth, credential)
                .then((result) => {
                    console.log("התחברות הצליחה!", result.user);
                    return result.user;
                })
                .catch((error) => {
                    console.error("שגיאה בהתחברות:", error);
                    throw error;
                });
        } catch (error) {
            console.error("שגיאה בעיבוד התשובה מגוגל:", error);
            throw error;
        }
    };

    // אתחול Google One Tap
    initialize() {
        if (this.isInitialized || !window.google?.accounts?.id) {
            return;
        }

        try {
            window.google.accounts.id.initialize({
                client_id: this.CLIENT_ID,
                callback: this.handleCredentialResponse,
                auto_select: false, // שינוי ל-false כדי לא לנסות אוטומטית
                cancel_on_tap_outside: false, // מונע סגירה בטעות בלחיצה בחוץ
                use_fedcm_for_prompt: false // מכבה FedCM שגורם לבעיות
            });

            this.isInitialized = true;
            console.log("Google One Tap אותחל בהצלחה");
        } catch (error) {
            console.error("שגיאה באתחול Google One Tap:", error);
        }
    }

    // הצגת הבועה על המסך
    prompt() {
        if (!this.isInitialized) {
            this.initialize();
        }

        if (window.google?.accounts?.id) {
            // בדיקה אם אנחנו ב-localhost
            const isLocalhost = window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1';

            if (isLocalhost) {
                console.log("רץ על localhost - וודא שהוספת http://localhost:3000 ב-Google Cloud Console");
            }

            window.google.accounts.id.prompt((notification) => {
                if (notification.isNotDisplayed()) {
                    console.log("Google One Tap לא הוצג - בדוק שהדומיין מוגדר ב-Google Cloud Console");
                } else if (notification.isSkippedMoment()) {
                    console.log("המשתמש סגר את Google One Tap - יוכל להשתמש בכפתור הרגיל");
                } else if (notification.isDismissedMoment()) {
                    console.log("Google One Tap נסגר");
                }
            });
        }
    }

    // ביטול Google One Tap
    cancel() {
        if (window.google?.accounts?.id) {
            window.google.accounts.id.cancel();
        }
    }
}

// יצירת instance יחיד
const googleOneTapService = new GoogleOneTapService();

export default googleOneTapService;